module.exports = __webpack_public_path__ + "static/media/9.c6c12af1.jpg";